export const getPageTitle = (tab) => {
    switch (tab) {
        case 'house':
            return 'House Investment Calculator | Calculate When You Can Afford To Buy A House';
        case 'mortgage':
            return 'House Mortgage Calculator | Calculate When You Can Afford To Buy A House With A Mortgage';
        default:
            return 'Investment Calculator | Compound Interest & Future Value Calculator';
    }
};

export const getPageDescription = (tab) => {
    switch (tab) {
        case 'house':
            return 'Calculate When You Can Afford To Buy A House. Calculate With And Without Monthly Contribution. Calculate With Different Interest Rates.';
        case 'mortgage':
            return 'Calculate When You Can Afford To Buy A House With A Mortgage.';
        default:
            return 'Calculate compound interest, future value, and investment returns. Compare different investment scenarios and see how your money can grow over time.';
    }
};

export const baseUrl = 'https://savematic.pro';

export const defaultMeta = {
    viewport: 'width=device-width, initial-scale=1',
    robots: 'index, follow',
    language: 'English',
    author: 'Savematic'
}; 